import React from 'react';

import './form.scss';

type Props = { handleUsers: (name: string) => void };
type State = { value: string; disabled: boolean };

class Form extends React.Component<Props, State> {
  baseState: State;

  constructor(props: Props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.baseState = this.state = { value: '', disabled: true };
  }

  handleChange(event: any) {
    const value = event.target.value.trim();
    const disabled = value ? false : true;
    this.setState({ value, disabled });
  }

  handleSubmit(event: any) {
    event.preventDefault();
    this.props.handleUsers(this.state.value.toLocaleLowerCase());
    this.setState(this.baseState);
  }

  render() {
    return (
      <form className="form" onSubmit={this.handleSubmit}>
        <input className="form-field" type="text" autoFocus placeholder="Name" value={this.state.value} onChange={this.handleChange} />
        <button className="form-button" type="submit" disabled={this.state.disabled}>
          Save
        </button>
      </form>
    );
  }
}

export default Form;
